/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// material
import { SubPage, Copy, Title, BodyCopy, CTAs, Button } from '@insticator/insticator-ui'; // iui-material
// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/account/users/deleteuser/deleteuser_styles';



/* ========== ~~~~~~~~~~ ACCOUNT EDIT USER ~~~~~~~~~~ ========== */
const DeleteUser =(props)=> {
    const handleDelete = () =>{
        props.deleteUser(props.userUUID, props.index);
        props.displayModal(false);
    };
    return(
        <SubPage name={`deleteuser`} klass={props.classes.deleteuser}>
            <Copy name={`deleteuser`}>
                <Title size={`medium`}>
                    <h2>Delete confirmation</h2>
                </Title>
                <BodyCopy>{`Are you sure you want to delete the user ${props.name} (${props.email})?`}</BodyCopy>
            </Copy>
            <CTAs name={`ctas`} >
                <Button type={`modal`} action={false} variant={`normal`} name={`cancel`} text={`Cancel`} />
                <Button type={'action'} action={handleDelete} variant={`delete`} name={`delete`} text={`Delete`} />
            </CTAs>
        </SubPage>
    );
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(DeleteUser);
